<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">API Keys</h3>
          <p class="page-head__sub">Use these keys to authenticate API requests.</p>
        </div>
        <div class="page-head__tools">
          <span class="page-pill"><i class="fa fa-key"></i> Credentials</span>
        </div>
      </div>
    </div>

    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card key-card mx-auto">
            <div class="card-header">
              <h4 class="card-title">Credentials</h4>
            </div>
            <div class="card-body">
              <form>
                <div class="form-group">
                  <label for="secretKey">Secret Key</label>
                  <div class="input-group">
                    <input
                      type="text"
                      [value]="secretKey"
                      class="form-control"
                      id="secretKey"
                      readonly
                      aria-label="Secret key"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        (click)="copySecret()"
                      >
                        Copy
                      </button>
                    </div>
                  </div>
                  <small class="form-text text-muted">
                    Keep this key secret. Never share it or expose it in client-side code.
                  </small>
                </div>
              </form>
              <form>
                <div class="form-group pt-4">
                  <label for="publicKey">Public Key</label>
                  <div class="input-group">
                    <input
                      type="text"
                      [value]="publicKey"
                      class="form-control"
                      id="publicKey"
                      readonly
                      aria-label="Public key"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        (click)="copyPublic()"
                      >
                        Copy
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-bottombar></app-bottombar>
